module.exports = __webpack_public_path__ + "img/oil-refinery.d82eb6b7.png";